import React, { useState } from "react";
import { EyeIcon, EyeOffIcon } from "@heroicons/react/outline";
import { twMerge } from "tailwind-merge";
import { REGEX_NUMBER } from "utills/constants";

type InputProps = {
  placeholder?: string;
  id?: string;
  label?: string;
  error?: any;
  type?: string;
  decimal?: number;
  [x: string]: any;
};

const PasswordInput = React.forwardRef((props: InputProps, ref: any) => {  
  const [isShowPassword, setIsShowPassword] = useState<boolean>(false);

  const _toggleShowPassword = () => {
    setIsShowPassword(!isShowPassword);
  };

  return (
    <div className="relative">
      <input
        {...props}
        ref={ref}
        type={isShowPassword ? "text" : "password"}
        className={`input ${
          props.error
            ? "border-red-600 focus:border-red-600"
            : "border-gray-300 focus:border-brand-500"
        }`}
        placeholder="••••••••"
      />
      <div
        className="absolute inset-y-0 right-2.5 flex items-center cursor-pointer"
        onClick={_toggleShowPassword}
      >
        {isShowPassword ? (
          <EyeIcon width={20} height={20} className="text-brand-500" />
        ) : (
          <EyeOffIcon width={20} height={20} className="text-brand-500" />
        )}
      </div>
    </div>
  );
});

const Input = React.forwardRef((props: InputProps, ref: any) => {
  const { decimal, ...rest } = props;
  switch (props.type) {
    case "checkbox":
      return (
        <div className="flex items-center">
          <input
            {...rest}
            type="checkbox"
            className={twMerge("checkbox", props.className)}
          />
          {props.label ? (
            <label
              htmlFor={props.id}
              className="ms-2 text-sm font-medium capitalize"
            >
              {props.label}
            </label>
          ) : null}
        </div>
      );
    case "password":
      return <PasswordInput {...rest} ref={ref} />;
    case "phone":
      return (
        <input
          {...rest}
          type="text"
          className={twMerge(
            `input ${
              props.error
                ? "border-red-600 focus:border-red-600"
                : "border-gray-300 focus:border-brand-500"
            }`,
            props.className
          )}
          onKeyDown={(e: any) => {
            if (REGEX_NUMBER.test(e.key) !== true && e.key !== "Backspace" && e.key !== "Delete") { // number only
              e.preventDefault();
              return false;
            }
            return true;
          }}
          ref={ref}
        />
      )
    case "number":
      return (
        <input
          {...rest}
          className={twMerge(
            `input ${
              props.error
                ? "border-red-600 focus:border-red-600"
                : "border-gray-300 focus:border-brand-500"
            }`,
            props.className
          )}
          onChange={(e) => {
            if (decimal) {
              let val = e.target.value;
              if (!/^\d*\.?\d*$/.test(val)) return;
              
              if (val.includes('.')) {
                const parts = val.split('.');
                if (parts[1] && parts[1].length > decimal) {
                  e.target.value = parts[0] + '.' + parts[1].substring(0, 2);
                }
              }
              props.onChange(e);
            } else {
              props.onChange(e);
            }
          }}
          ref={ref}
          step="any"
        />
      );
    default:
      return (
        <input
          {...rest}
          className={twMerge(
            `input ${
              props.error
                ? "border-red-600 focus:border-red-600"
                : "border-gray-300 focus:border-brand-500"
            }`,
            props.className
          )}
          ref={ref}
        />
      );
  }
});

Input.displayName = "Input";

export default Input;
